import React from "react";
import { Box, Grid, Typography, Chip } from "@mui/material";
import PageHeader from "../../components/PageHeader";
import SectionCard from "../../components/SectionCard";
import { tokens } from "../../theme";
import { guardrails, budgetPacing, roles, auditLog } from "../../data/mockData";

const mono = '"IBM Plex Mono", monospace';
const th = { textAlign: "left", color: tokens.textDim, fontSize: 10.5, textTransform: "uppercase", letterSpacing: 0.5, fontWeight: 700, padding: "10px 12px", borderBottom: `1px solid ${tokens.border}`, whiteSpace: "nowrap" };
const td = { padding: "11px 12px", borderBottom: `1px solid ${tokens.border}`, fontSize: 12.5, verticalAlign: "middle" };

export default function Audit() {
  return (
    <Box>
      <PageHeader title="Audit & Admin" crumb="Intelligence / Audit & Admin" subtitle="Immutable log · guardrails · roles" />

      <Grid container spacing={1.75}>
        <Grid item xs={12} md={6}>
          <SectionCard title="Guardrails (hard gates)" subtitle="Nothing — however high its priority — bypasses these" sx={{ height: "100%" }}>
            {guardrails.map(([l, v]) => (
              <Box key={l} sx={{ display: "flex", py: 0.8, borderBottom: `1px solid ${tokens.border}` }}>
                <Typography variant="caption" color="text.secondary">{l}</Typography>
                <Typography sx={{ ml: "auto", fontFamily: mono, fontSize: 12, fontWeight: 600 }}>{v}</Typography>
              </Box>
            ))}
          </SectionCard>
        </Grid>

        <Grid item xs={12} md={6}>
          <SectionCard title="Campaign budget pacing" subtitle="Throttles or stops when spent" sx={{ height: "100%" }}>
            {budgetPacing.map(([name, spent, budget, status]) => {
              const pct = Math.round((spent / budget) * 100);
              return (
                <Box key={name} sx={{ mb: 1.4 }}>
                  <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0.5 }}>
                    <Typography variant="caption">
                      {name} {status === "paused" && <Chip size="small" label="spent" sx={{ ml: 0.5, height: 18, fontSize: 10, bgcolor: "rgba(245,166,35,0.13)", color: tokens.amber }} />}
                    </Typography>
                    <Typography sx={{ fontFamily: mono, fontSize: 12 }}>${(spent / 1000).toFixed(1)}k / ${(budget / 1000).toFixed(0)}k</Typography>
                  </Box>
                  <Box sx={{ height: 7, borderRadius: 4, background: tokens.bg, overflow: "hidden" }}>
                    <Box sx={{ height: "100%", width: `${pct}%`, background: spent >= budget ? tokens.danger : tokens.accent, borderRadius: 4 }} />
                  </Box>
                </Box>
              );
            })}
          </SectionCard>
        </Grid>

        <Grid item xs={12}>
          <SectionCard title="Roles" subtitle="Who can do what">
            {roles.map(([role, perms]) => (
              <Box key={role} sx={{ display: "flex", alignItems: "center", py: 0.8, borderBottom: `1px solid ${tokens.border}` }}>
                <Chip size="small" label={role} sx={{ bgcolor: tokens.surface2, color: tokens.text, fontWeight: 600 }} />
                <Typography variant="caption" color="text.secondary" sx={{ ml: "auto" }}>{perms}</Typography>
              </Box>
            ))}
          </SectionCard>
        </Grid>

        <Grid item xs={12}>
          <SectionCard title="Audit log" subtitle="Immutable — every action recorded">
            <Box sx={{ overflowX: "auto" }}>
              <Box component="table" sx={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr><th style={th}>Time</th><th style={th}>Actor</th><th style={th}>Action</th><th style={th}>Target</th><th style={th}>Reason</th></tr></thead>
                <tbody>
                  {auditLog.map((a, i) => (
                    <tr key={i}>
                      <td style={{ ...td, fontFamily: mono, color: tokens.textDim }}>{a.time}</td>
                      <td style={{ ...td, fontWeight: 600 }}>{a.actor}</td>
                      <td style={td}>{a.action}</td>
                      <td style={{ ...td, fontFamily: mono, fontSize: 11.5 }}>{a.target}</td>
                      <td style={{ ...td, color: tokens.textDim }}>{a.reason}</td>
                    </tr>
                  ))}
                </tbody>
              </Box>
            </Box>
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );
}
